import { ComponentProps } from 'react';
import { DeliveryStatus } from 'api/models/Deliveries';
import StatusChip from 'components/StatusChip/StatusChip';
import useStatusTranslations from 'hooks/useStatusTranslations';

type Props = { status: DeliveryStatus } & ComponentProps<typeof StatusChip>;

export const DeliveryStatusChip = ({ status, ...props }: Props) => {
  const statusLang = useStatusTranslations();
  const statusText = statusLang[status];

  return (
    <StatusChip status={status} {...props}>
      {statusText}
    </StatusChip>
  );
};
